import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const getRenewalAndEmails = createAsyncThunk("get-renewal-and-emails", async () => {
    const response = await api.getSimpleObject("placeholder/renewal-and-emails")
    return response
})

const renewalAndEmailSlice = createSlice({
    name: "renewal-and-email",
    initialState: {
        data: [],
        renewalAndEmail: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateRenewalAndEmail(state, action) {
            const { field, value } = action.payload
            state.renewalAndEmail = { ...state.renewalAndEmail, [field]: value }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRenewalAndEmails.fulfilled, (state, action) => {
                state.data = action.payload
                state.fetchStatus = "success"
                state.action = "getRenewalAndEmails"
            })
            .addCase(getRenewalAndEmails.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getRenewalAndEmails"
            })
            .addCase(getRenewalAndEmails.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getRenewalAndEmails"
            })
    }
})

export default renewalAndEmailSlice

export const { name, actions, reducers } = renewalAndEmailSlice
